import { LoggerService } from './../../../../services/logger/logger.service';
import { Injectable } from '@angular/core';
import { DeviceSettingsFeatureToggle } from 'src/app/enums/feature-toggle.enum';
import { ISectionPresenter } from 'src/app/presenters/models/section-presenter';
import { CameraSectionService } from 'src/app/services/camera/camera-section/camera-section.service';
import { DisplayService } from 'src/app/services/display/display.service';
import { FeatureToggleService } from 'src/app/services/feature-toggle/feature-toggle.service';
import { LocalStorageKey } from 'src/app/enums/local-storage-key.enum';
import { CommonService } from 'src/app/services/common/common.service';

@Injectable({
	providedIn: 'root',
})
export class CameraSection implements ISectionPresenter {
	constructor(
		private cameraSectionService: CameraSectionService,
		private commonService: CommonService,
		private displayService: DisplayService,
		private logger: LoggerService,
		private featureToggleService: FeatureToggleService,
	) {}

	public async isVisible(): Promise<boolean> {
		const isCameraFeatureAvailable = this.isFeatureToggleEnabled();
		if(!isCameraFeatureAvailable) {
			this.logger.info('isCameraSectionVisible - featureToggle', false);
			return false;
		}

		const [cameraPrivacyStatus, isAllInOneMachine, hiddenByBios] = await Promise.all([
			this.displayService.getCameraPrivacyModeState(),
			this.cameraSectionService.isAllInOneMachine(),
			this.cameraSectionService.isN2PBios()
		]);

		const isCameraSectionVisible = (cameraPrivacyStatus?.available || !hiddenByBios) && isAllInOneMachine;
		this.logger.info('isCameraSectionVisible', isCameraSectionVisible);
		this.commonService.setLocalStorageValue(LocalStorageKey.isCameraSectionVisible, isCameraSectionVisible)

		return isCameraSectionVisible;
	}


	public isFeatureToggleEnabled()  {
		const isCameraSectionVisible = this.featureToggleService.isDeviceSettingsFeatureAvailable(
			DeviceSettingsFeatureToggle.DisplayAndCameraCamera
		);

		return isCameraSectionVisible;
	}
}
